module.exports = __webpack_public_path__ + "img/enterpreneurship_1.062f479b.jpg";